import { render, staticRenderFns } from "./AddSurvey.vue?vue&type=template&id=5e8dc2d7&"
import script from "./AddSurvey.vue?vue&type=script&lang=js&"
export * from "./AddSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports